import axios from 'axios';

const BASE_URL = '/app/pipelineStageMoveFunnel';

export const getPipelineConfiguration = async () => {
    const { data } = await axios.get(BASE_URL);

    return data;
};
